import { forwardRef, useImperativeHandle, useState } from 'react';

/** A guide line in SCREEN coords: vertical ('x') at x=`at` spanning y∈[from,to], or horizontal ('y'). */
export interface ScreenGuide {
  axis: 'x' | 'y';
  at: number;
  from: number;
  to: number;
}

export interface SnapGuidesHandle {
  show: (guides: ScreenGuide[]) => void;
  clear: () => void;
}

const GUIDE = '#f43f5e'; // rose — matches Miro's magenta alignment guides, distinct from the accent selection

/**
 * Alignment guide overlay. Updated IMPERATIVELY (via ref) from the move/drag handlers so a drag doesn't
 * re-render the whole canvas — only this tiny layer repaints. Screen-space, above the canvas, below UI.
 */
const SnapGuidesLayer = forwardRef<SnapGuidesHandle>(function SnapGuidesLayer(_props, ref) {
  const [guides, setGuides] = useState<ScreenGuide[]>([]);
  useImperativeHandle(ref, () => ({ show: setGuides, clear: () => setGuides([]) }), []);
  if (guides.length === 0) return null;
  return (
    <div className="pointer-events-none absolute inset-0 z-30">
      {guides.map((g, i) =>
        g.axis === 'x' ? (
          <div
            key={i}
            style={{ position: 'absolute', left: g.at, top: g.from, width: 1, height: g.to - g.from, background: GUIDE }}
          />
        ) : (
          <div
            key={i}
            style={{ position: 'absolute', left: g.from, top: g.at, width: g.to - g.from, height: 1, background: GUIDE }}
          />
        ),
      )}
    </div>
  );
});

export default SnapGuidesLayer;
